import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { FeatureService } from 'src/core/services/feature/feature.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';

@Component({
    selector: 'ca-real-time-voice-biometrics-settings',
    templateUrl: './real-time-voice-biometrics-settings.component.html',
    styleUrls: ['./real-time-voice-biometrics-settings.component.scss'],
    standalone: false
})
export class RealTimeVoiceBiometricsSettingsComponent implements OnInit {
  form: FormGroup;
  voiceBiometricsIntegration = false;

  private readonly prefix = 'VoiceBiometrics';
  private readonly endpoint = this.prefix + '.Endpoint';
  private readonly identityBaseEndpoint = this.prefix + '.IdentityBaseEndpoint';
  private readonly clientId = this.prefix + '.ClientId';
  private readonly clientSecret = this.prefix + '.ClientSecret';

  get isSavedBefore(): boolean {
    if (this.config.getSetting(this.identityBaseEndpoint)) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService,
    private featureService: FeatureService
  ) {
    this.voiceBiometricsIntegration = this.featureService.isEnabled(
      FeatureConstants.VoiceBiometricsIntegration
    );

    this.form = this.fb.group({
      endpoint: this.fb.group({
        name: this.endpoint,
        value: [
          this.config.getSetting(this.endpoint),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      identityBaseEndpoint: this.fb.group({
        name: this.identityBaseEndpoint,
        value: [
          this.config.getSetting(this.identityBaseEndpoint),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      clientId: this.fb.group({
        name: this.clientId,
        value: [
          this.config.getSetting(this.clientId),
          {
            validators: [this.passwordValidator.bind(this), StringValidator.whitespace],
          },
        ],
      }),
      clientSecret: this.fb.group({
        name: this.clientSecret,
        value: [
          this.config.getSetting(this.clientSecret),
          {
            validators: [this.passwordValidator.bind(this), StringValidator.whitespace],
          },
        ],
      }),
    });
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }
    const settings: ConfigurationSettingsDto[] = [];

    settings.push(
      {
        settingName: this.form.get('endpoint').get('name').value,
        settingValue: this.form.get('endpoint').get('value').value,
      },
      {
        settingName: this.form.get('identityBaseEndpoint').get('name').value,
        settingValue: this.form.get('identityBaseEndpoint').get('value').value,
      }
    );

    if (this.form.get('clientSecret').get('value').value) {
      settings.push({
        settingName: this.form.get('clientSecret').get('name').value,
        settingValue: this.form.get('clientSecret').get('value').value,
      });
    }

    if (this.form.get('clientId').get('value').value) {
      settings.push({
        settingName: this.form.get('clientId').get('name').value,
        settingValue: this.form.get('clientId').get('value').value,
      });
    }

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }

  passwordValidator(control: FormGroup) {
    if (!this.isSavedBefore && !control.value) {
      return { required: true };
    }

    return null;
  }
}
